import { RouterOutlet } from '@angular/router';
import { signal, Component } from '@angular/core';

import { Toast } from '@shared/components/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('rainbow-surrogacy-admin');
}
